import React, { useMemo } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { Box, Button, Flex, Heading } from '@chakra-ui/react'

import useGCMaterial from '@/features/GCMaterials/useGCMaterials'
import { validateFormRequiredFields } from '@/utils/form.helper'
import { renderFormField } from '@/utils/renderForm'
import { toast } from 'react-toastify'
import GCMATERIAL_FIELD_SCHEMA from '../constants/GCMaterialFieldSchema'

const defaultValues = GCMATERIAL_FIELD_SCHEMA.reduce((acc, field) => {
  acc[field.name] = field.defaultValue
  return acc
}, {})

const requiredFields = GCMATERIAL_FIELD_SCHEMA.filter((field) => field.required).reduce((acc, field) => {
  acc[field.name] = field.label
  return acc
}, {})

const CreateGCMaterialPage = () => {
  const [searchParams] = useSearchParams()

  // Compute defaultValues from query parameters or use schema defaults
  const computedDefaultValues = useMemo(() => {
    const baseDefaults = { ...defaultValues }

    // Parse query parameters and merge with defaults
    const queryDefaults = {}
    GCMATERIAL_FIELD_SCHEMA.forEach((field) => {
      const paramValue = searchParams.get(field.name)
      if (paramValue !== null) {
        // Convert to appropriate type
        if (field.type === 'number') {
          queryDefaults[field.name] = paramValue === '' ? field.defaultValue : Number(paramValue)
        } else {
          queryDefaults[field.name] = paramValue
        }
      }
    })

    return {
      ...baseDefaults,
      ...queryDefaults,
    }
  }, [searchParams])

  //State
  const methods = useForm({
    defaultValues: computedDefaultValues,
  })
  const navigate = useNavigate()
  const { useCreateGCMaterial } = useGCMaterial()
  const createGCMaterial = useCreateGCMaterial()

  const onSubmit = async (data) => {
    try {
      validateFormRequiredFields(data, requiredFields)

      const res = await createGCMaterial.mutateAsync({
        ...data,
      })

      console.log('res', res)
      if (res?.data?._id) {
        navigate(`/admin/GCMaterials/${res?.data?._id}`)
      }
    } catch (err) {
      toast.error(err?.message ?? '')
    }
  }

  return (
    <Box shadow="md" borderWidth="1px" bg="white" w="100%" mb="auto">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)} autoComplete="off">
          <Flex p={5} borderBottom="1px solid #d8dbe0">
            <Heading> Create GC Material </Heading>
          </Flex>
          <Box p="5">
            <Flex direction={'column'} gap="3">
              {GCMATERIAL_FIELD_SCHEMA.map(renderFormField)}
            </Flex>

            <Button mt="6" colorScheme="blue" type="submit">
              Save
            </Button>
          </Box>
        </form>
      </FormProvider>
    </Box>
  )
}

export default CreateGCMaterialPage
